import { useState } from 'react';
import {
  ButtonPseudo,
  IconClose,
  IconSearch,
  InputSize,
  InputText,
} from '@ui/src';
import { ColumnHeaderTypes } from './types';

import cn from './notification-settings.module.css';

const NotificationSettingsColumnHeader = ({
  className,
  title,
  value,
  onSearch,
  selectedId,
}: ColumnHeaderTypes) => {
  const [inputOpen, setInputOpen] = useState(Boolean(value));

  let content;

  if (onSearch) {
    content = inputOpen ? (
      <div className={`${cn.columnHeaderWrapper} ${cn.columnInputWrapper}`}>
        <div className={cn.inputWrapper}>
          <InputText
            placeholder="Find settings..."
            name="search"
            size={InputSize.SMALL}
            labelClassName={cn.searchInput}
            value={value}
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>
        <ButtonPseudo
          icon={<IconClose />}
          className="button-white"
          onClick={() => {
            setInputOpen(false);
            onSearch('');
          }}
        />
      </div>
    ) : (
      <div className={cn.columnHeaderWrapper}>
        <div className={cn.columnTitle}>{title}</div>
        {selectedId && (
          <ButtonPseudo
            icon={<IconSearch />}
            className={`button-white ${cn.searchButton}`}
            onClick={() => setInputOpen(true)}
          />
        )}
      </div>
    );
  } else {
    content = <div className={cn.columnTitle}>{title}</div>;
  }

  return <div className={`${cn.columnHeader} ${className}`}>{content}</div>;
};

export default NotificationSettingsColumnHeader;
